import functions from "./functions.js";

$(function () {
    let $tracking = $('.gatracking');

    if ($tracking.length)
    {
        let trackingData = JSON.parse($('[data-gatracking]').attr('data-gatracking'));

        if (trackingData) gtag(...trackingData);

    }

    $('.klaviyotracking').each(function () {
        var data = JSON.parse($(this).attr('data-klaviyotracking'));
        if (data) klaviyo.track(data[1], data[2]);
    });
});